import { currentChannel } from "@/config/config";
import { LOCAL_STORE } from "@/config/constConfig";
import { reqCordovaChcp } from "@/handle/chcpHandle";

/**adjust事件 */
export namespace AdJustAndroidEvent {

    function sendAdJustEvent(eventName: string, goldNum: number = 0) {
        let adjustData = localStorage.getItem(LOCAL_STORE.ADJUST_DATA);
        if (adjustData) {
            console.log("eventName===========>>", eventName);
            let params: any = {
                eventName: eventName,
            }
            if (goldNum > 0) {
                params.gold = goldNum;
                params.currency = currentChannel.currency;
            }
            reqCordovaChcp("reqAdjust", params);
        }
    }

    /**注册 */
    export function registerAdjust() {
        sendAdJustEvent("register_complete");
    }

    /**首充 */
    export function firstRecharge(goldNum: number) {
        sendAdJustEvent("first_recharge", goldNum);
    }

    /**总充值 */
    export function Rechargesuccess(goldNum: number) {
        sendAdJustEvent("af_rechargesuccess", goldNum);
    }

    /**注册当日总充 */
    export function Totalpurchase(goldNum: number) {
        sendAdJustEvent("ftd_totalpurchase", goldNum);
    }
}